import { HotelBookingError } from "@/types/hotels/hotels"
import {
  CaseReducer,
  createSelector,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit"

import { RootState } from "./redux-store"

export interface HotelBookingSliceState {
  submitting: boolean
  submitError: HotelBookingError | undefined
  creditCardError?: string
}

export const hotelBookingSliceInitialState: HotelBookingSliceState = {
  submitting: false,
  submitError: undefined,
  creditCardError: undefined,
}

export const selectHotelBookingState = (state: RootState) =>
  state.hotelBookingSlice

export const selectSubmitting = createSelector(
  [selectHotelBookingState],
  (HotelBookingSliceState) => HotelBookingSliceState.submitting
)

export const selectSubmitError = createSelector(
  [selectHotelBookingState],
  (HotelBookingSliceState) => HotelBookingSliceState.submitError
)

export const selectCreditCardError = createSelector(
  [selectHotelBookingState],
  (HotelBookingSliceState) => HotelBookingSliceState.creditCardError
)

const setSubmitting: CaseReducer<
  HotelBookingSliceState,
  PayloadAction<boolean>
> = (state, action) => {
  state.submitting = action.payload
  if (state.submitting) {
    state.submitError = undefined
    state.creditCardError = undefined
  }
}

const setSubmitError: CaseReducer<
  HotelBookingSliceState,
  PayloadAction<HotelBookingError | undefined>
> = (state, action) => {
  state.submitError = action.payload
}

const setCreditCardError: CaseReducer<
  HotelBookingSliceState,
  PayloadAction<string | undefined>
> = (state, action) => {
  state.creditCardError = action.payload
}

const hotelBookingSlice = createSlice({
  name: "hotel-booking",
  initialState: hotelBookingSliceInitialState,
  reducers: {
    setSubmitting,
    setSubmitError,
    setCreditCardError,
  },
})

export type hotelBookingSlice = typeof hotelBookingSlice

export default hotelBookingSlice
